var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hobbies--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "303.71 265.94 294.5 274.41 302.23 282.87 303.71 265.94",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.71 265.94 294.5 274.41 302.23 282.87 303.71 265.94",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.21,299.1H302.12a1.64,1.64,0,0,1-1.66-1.82l3.1-35.44a2,2,0,0,1,2-1.82h53.08a1.64,1.64,0,0,1,1.66,1.82l-3.1,35.44A2,2,0,0,1,355.21,299.1Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.21,299.1H302.12a1.64,1.64,0,0,1-1.66-1.82l3.1-35.44a2,2,0,0,1,2-1.82h53.08a1.64,1.64,0,0,1,1.66,1.82l-3.1,35.44A2,2,0,0,1,355.21,299.1Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.49,265.06l-2.54,29a1.65,1.65,0,0,0,1.67,1.82h46.65a2,2,0,0,0,2-1.82l2.54-29a1.64,1.64,0,0,0-1.66-1.82H308.47A2,2,0,0,0,306.49,265.06Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.49,265.06l-2.54,29a1.65,1.65,0,0,0,1.67,1.82h46.65a2,2,0,0,0,2-1.82l2.54-29a1.64,1.64,0,0,0-1.66-1.82H308.47A2,2,0,0,0,306.49,265.06Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.56,295.89A15.6,15.6,0,0,0,335,281.28h-4.68a1.7,1.7,0,0,1-1.46-.87c-.67-1.11-1.64-2.1-1.46-3.17.27-1.64,2.07-2.54,2.07-4.17a5.2,5.2,0,0,0-1.22-3.31,6.13,6.13,0,0,0-.78-4.77A6.1,6.1,0,0,0,323,267.2l-.59,0-.58,0a6.1,6.1,0,0,0-4.43-2.21,6.13,6.13,0,0,0-.78,4.77,5.2,5.2,0,0,0-1.22,3.31c0,1.7,1.94,2.59,2.26,4.31,1.09,5.92-2.67,14.72-4.48,18.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.87,295.84c5.6-2.24,3.66,10.42,3.48,13.05-.24,3.61-.23,7.35,4.18,7.63,1.35.08,1.34-2,0-2.1-3.64-.23-1.93-7-1.78-9.37.19-2.83.55-6.19-.75-8.84a4.47,4.47,0,0,0-5.69-2.4c-1.24.5-.69,2.53.56,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.77,272.21a2.35,2.35,0,0,0,3.61,0c.33-.36-.2-.89-.53-.53a1.61,1.61,0,0,1-2.55,0c-.33-.36-.86.18-.53.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.6,272.21a2.35,2.35,0,0,0,3.61,0c.33-.36-.2-.89-.53-.53a1.61,1.61,0,0,1-2.55,0c-.33-.36-.86.18-.53.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.88,295.89H312.8a2.52,2.52,0,0,1-2.52-2.53h0a.92.92,0,0,1,.92-.92h13.29a.92.92,0,0,1,.92.92h0A2.53,2.53,0,0,1,322.88,295.89Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.88,295.89H312.8a2.52,2.52,0,0,1-2.52-2.53h0a.92.92,0,0,1,.92-.92h13.29a.92.92,0,0,1,.92.92h0A2.53,2.53,0,0,1,322.88,295.89Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.92,326.35H155.3a2,2,0,0,1-2-2.21l4.17-47.62a2.46,2.46,0,0,1,2.4-2.22h47.62a2,2,0,0,1,2,2.22l-4.16,47.62A2.47,2.47,0,0,1,202.92,326.35Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.92,326.35H155.3a2,2,0,0,1-2-2.21l4.17-47.62a2.46,2.46,0,0,1,2.4-2.22h47.62a2,2,0,0,1,2,2.22l-4.16,47.62A2.47,2.47,0,0,1,202.92,326.35Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.25,279.2l-3.7,42.25a1.68,1.68,0,0,0,1.7,1.86H200.5a2.06,2.06,0,0,0,2-1.86l3.7-42.25a1.68,1.68,0,0,0-1.7-1.86H162.27A2.07,2.07,0,0,0,160.25,279.2Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.25,279.2l-3.7,42.25a1.68,1.68,0,0,0,1.7,1.86H200.5a2.06,2.06,0,0,0,2-1.86l3.7-42.25a1.68,1.68,0,0,0-1.7-1.86H162.27A2.07,2.07,0,0,0,160.25,279.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.39 307.7 216.97 297.97 208.09 288.24 206.39 307.7",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.39 307.7 216.97 297.97 208.09 288.24 206.39 307.7",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,270.13H153.59a3.21,3.21,0,0,0-3.21,3.2v38.43c0,1.42,3.83,5.25,5.25,5.25h38.43a3.21,3.21,0,0,0,3.2-3.21V275.38C197.26,274,193.43,270.13,192,270.13Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,270.13H153.59a3.21,3.21,0,0,0-3.21,3.2v38.43c0,1.42,3.83,5.25,5.25,5.25h38.43a3.21,3.21,0,0,0,3.2-3.21V275.38C197.26,274,193.43,270.13,192,270.13Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.46,
    y: 269.13,
    width: 44.83,
    height: 44.83,
    rx: 3.41,
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.46,
    y: 269.13,
    width: 44.83,
    height: 44.83,
    rx: 3.41,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.88,
    cy: 292.49,
    r: 15.96,
    transform: "translate(-152.27 392.57) rotate(-76.72)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.88,
    cy: 292.49,
    r: 15.96,
    transform: "translate(-152.27 392.57) rotate(-76.72)",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.88,
    cy: 290.6,
    r: 15.96,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.28,283.77a15.74,15.74,0,0,0-7.56-7.57l-6.51,14.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.48,297.44a15.63,15.63,0,0,0,7.57,7.56l6.5-14.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.28,283.77a15.74,15.74,0,0,0-7.56-7.57l-6.51,14.07Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.48,297.44a15.63,15.63,0,0,0,7.57,7.56l6.5-14.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93,290.6a5.05,5.05,0,1,1-5.05-5.05A5,5,0,0,1,176.93,290.6Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.82,289.66a.94.94,0,0,0-1.88,0v.94a.94.94,0,0,0,1.88,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.88,
    cy: 289.66,
    r: 0.94,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.76,309.23h0a.65.65,0,0,1-.65-.65v-6a.65.65,0,0,1,.65-.65h0a.65.65,0,0,1,.64.65v6A.65.65,0,0,1,153.76,309.23Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.76,309.23h0a.65.65,0,0,1-.65-.65v-6a.65.65,0,0,1,.65-.65h0a.65.65,0,0,1,.64.65v6A.65.65,0,0,1,153.76,309.23Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.11,
    y: 303.52,
    width: 5.29,
    height: 2.24,
    rx: 1.12,
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.11,
    y: 303.52,
    width: 5.29,
    height: 2.24,
    rx: 1.12,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,273.29a1.49,1.49,0,0,0-1.49,1.49v4.71a1.48,1.48,0,0,0,.79,1.3v21.93h-1.14a1.49,1.49,0,0,0-1.49,1.49v3a1.49,1.49,0,0,0,1.49,1.49h1.14a.71.71,0,0,0,1.41,0V280.79a1.49,1.49,0,0,0,.78-1.3v-4.71A1.49,1.49,0,0,0,190,273.29Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,273.29a1.49,1.49,0,0,0-1.49,1.49v4.71a1.48,1.48,0,0,0,.79,1.3v21.93h-1.14a1.49,1.49,0,0,0-1.49,1.49v3a1.49,1.49,0,0,0,1.49,1.49h1.14a.71.71,0,0,0,1.41,0V280.79a1.49,1.49,0,0,0,.78-1.3v-4.71A1.49,1.49,0,0,0,190,273.29Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.6,254.09a.24.24,0,0,0-.36-.2c-1.88,1-2.94-3.93-4.89-2.3a.28.28,0,0,0-.1.2v.28h0v9.74a3.33,3.33,0,0,0-1.8-.47c-1.71,0-3.34.93-3.64,2.08s.82,2.08,2.52,2.08,3.34-.93,3.64-2.08a1.41,1.41,0,0,0,.05-.4h0v-8.88c1.63-.19,2.68,3.94,4.49,2.43a.27.27,0,0,0,.09-.2Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.6,254.09a.24.24,0,0,0-.36-.2c-1.88,1-2.94-3.93-4.89-2.3a.28.28,0,0,0-.1.2v.28h0v9.74a3.33,3.33,0,0,0-1.8-.47c-1.71,0-3.34.93-3.64,2.08s.82,2.08,2.52,2.08,3.34-.93,3.64-2.08a1.41,1.41,0,0,0,.05-.4h0v-8.88c1.63-.19,2.68,3.94,4.49,2.43a.27.27,0,0,0,.09-.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.73,265a.2.2,0,0,0-.3-.17c-1.58.86-2.48-3.31-4.12-1.94a.23.23,0,0,0-.08.17v.23h0v8.21a2.76,2.76,0,0,0-1.52-.4c-1.43,0-2.81.79-3.07,1.75s.7,1.76,2.13,1.76,2.81-.79,3.07-1.76a1.32,1.32,0,0,0,0-.34h0v-7.47c1.37-.16,2.25,3.32,3.78,2.05a.22.22,0,0,0,.07-.17Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.73,265a.2.2,0,0,0-.3-.17c-1.58.86-2.48-3.31-4.12-1.94a.23.23,0,0,0-.08.17v.23h0v8.21a2.76,2.76,0,0,0-1.52-.4c-1.43,0-2.81.79-3.07,1.75s.7,1.76,2.13,1.76,2.81-.79,3.07-1.76a1.32,1.32,0,0,0,0-.34h0v-7.47c1.37-.16,2.25,3.32,3.78,2.05a.22.22,0,0,0,.07-.17Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.66,246.85a.2.2,0,0,0-.31-.17c-1.61.88-2.53-3.38-4.21-2a.23.23,0,0,0-.08.17v.24h0v8.38a2.87,2.87,0,0,0-1.55-.41c-1.47,0-2.87.81-3.13,1.79s.7,1.79,2.17,1.79,2.87-.8,3.13-1.79a1,1,0,0,0,0-.34h0V246.9c1.4-.17,2.3,3.38,3.85,2.08a.23.23,0,0,0,.08-.17Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.66,246.85a.2.2,0,0,0-.31-.17c-1.61.88-2.53-3.38-4.21-2a.23.23,0,0,0-.08.17v.24h0v8.38a2.87,2.87,0,0,0-1.55-.41c-1.47,0-2.87.81-3.13,1.79s.7,1.79,2.17,1.79,2.87-.8,3.13-1.79a1,1,0,0,0,0-.34h0V246.9c1.4-.17,2.3,3.38,3.85,2.08a.23.23,0,0,0,.08-.17Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.13,234.82H310.75a2,2,0,0,1-2-2.21l5-57.38a2.47,2.47,0,0,1,2.41-2.21h57.38a2,2,0,0,1,2,2.21l-5,57.38A2.45,2.45,0,0,1,368.13,234.82Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.13,234.82H310.75a2,2,0,0,1-2-2.21l5-57.38a2.47,2.47,0,0,1,2.41-2.21h57.38a2,2,0,0,1,2,2.21l-5,57.38A2.45,2.45,0,0,1,368.13,234.82Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,178.83,312.65,229a2,2,0,0,0,2,2.21h50.17a2.45,2.45,0,0,0,2.4-2.21l4.39-50.17a2,2,0,0,0-2-2.21H319.45A2.47,2.47,0,0,0,317,178.83Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,178.83,312.65,229a2,2,0,0,0,2,2.21h50.17a2.45,2.45,0,0,0,2.4-2.21l4.39-50.17a2,2,0,0,0-2-2.21H319.45A2.47,2.47,0,0,0,317,178.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,173.37c0-3.05-3.21-2.34-7.17-2.34s-7.17-.71-7.17,2.34a3.11,3.11,0,0,0,1.31,2.64h-.37c-4.37,0-7.91-.13-7.91,3.63a6.58,6.58,0,0,0,3.39,5.59,3.93,3.93,0,0,0-2.2,3.43c0,2.2,2,2.39,4.44,2.39h.41a4,4,0,0,0-.55,4.93c-.2,0-.4,0-.61,0-3.21,0-5.8,1.78-5.87,4l-.41,0c-5.44,0-9.86,3.08-9.86,6.88s4.42,6.87,9.86,6.87,9.86-3.08,9.86-6.87a5.73,5.73,0,0,0-2.18-4.31c2.56-.1,4.47-.55,4.47-2.47a3.29,3.29,0,0,0-1-2.25,4,4,0,0,0-.06-7.82,2.21,2.21,0,0,0,.34-1.28,3.69,3.69,0,0,0-.83-2.31c3.74-.54,6.6-3.33,6.6-6.71a3.19,3.19,0,0,0-.82-2.36C343.21,177.15,346,176.19,346,173.37Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,173.37c0-3.05-3.21-2.34-7.17-2.34s-7.17-.71-7.17,2.34a3.11,3.11,0,0,0,1.31,2.64h-.37c-4.37,0-7.91-.13-7.91,3.63a6.58,6.58,0,0,0,3.39,5.59,3.93,3.93,0,0,0-2.2,3.43c0,2.2,2,2.39,4.44,2.39h.41a4,4,0,0,0-.55,4.93c-.2,0-.4,0-.61,0-3.21,0-5.8,1.78-5.87,4l-.41,0c-5.44,0-9.86,3.08-9.86,6.88s4.42,6.87,9.86,6.87,9.86-3.08,9.86-6.87a5.73,5.73,0,0,0-2.18-4.31c2.56-.1,4.47-.55,4.47-2.47a3.29,3.29,0,0,0-1-2.25,4,4,0,0,0-.06-7.82,2.21,2.21,0,0,0,.34-1.28,3.69,3.69,0,0,0-.83-2.31c3.74-.54,6.6-3.33,6.6-6.71a3.19,3.19,0,0,0-.82-2.36C343.21,177.15,346,176.19,346,173.37Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.11,206.79a5.73,5.73,0,0,0-2.18-4.31c2.56-.1,4.47-.55,4.47-2.47a3.29,3.29,0,0,0-1-2.25,3.12,3.12,0,0,0,.59-.19c-3.48.16-6.24,2.06-6.24,4.4a3,3,0,0,0,.29,1.21c-2.58.62-4.42,2.23-4.42,4.15,0,2.18,2.39,4,5.54,4.34A6.05,6.05,0,0,0,333.11,206.79Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.16,190.84c-1.67.8-2.76,2.09-2.76,3.56a3.79,3.79,0,0,0,1.88,3,4,4,0,0,0,.88-6.61Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.11,206.79a5.73,5.73,0,0,0-2.18-4.31c2.56-.1,4.47-.55,4.47-2.47a3.29,3.29,0,0,0-1-2.25,3.12,3.12,0,0,0,.59-.19c-3.48.16-6.24,2.06-6.24,4.4a3,3,0,0,0,.29,1.21c-2.58.62-4.42,2.23-4.42,4.15,0,2.18,2.39,4,5.54,4.34A6.05,6.05,0,0,0,333.11,206.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.16,190.84c-1.67.8-2.76,2.09-2.76,3.56a3.79,3.79,0,0,0,1.88,3,4,4,0,0,0,.88-6.61Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.94,209v8.83c0,6.21-5.08,8.1-11.29,8.1h0c-6.21,0-11.29-1.89-11.29-8.1V209a2.59,2.59,0,0,1,2.59-2.59h17.4A2.59,2.59,0,0,1,334.94,209Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.94,209v8.83c0,6.21-5.08,8.1-11.29,8.1h0c-6.21,0-11.29-1.89-11.29-8.1V209a2.59,2.59,0,0,1,2.59-2.59h17.4A2.59,2.59,0,0,1,334.94,209Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.21,209a7.14,7.14,0,0,0-3.27.19v2.73a3.77,3.77,0,0,1,2.44-.37c1.91.34,2.36,1.84,2.06,3.54s-1.26,2.94-3.17,2.6a3.88,3.88,0,0,1-1.33-.51v.62a9.31,9.31,0,0,1-.23,2.12,7,7,0,0,0,1.45.44c3.54.64,5.29-1.67,5.86-4.81S341.74,209.65,338.21,209Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.21,209a7.14,7.14,0,0,0-3.27.19v2.73a3.77,3.77,0,0,1,2.44-.37c1.91.34,2.36,1.84,2.06,3.54s-1.26,2.94-3.17,2.6a3.88,3.88,0,0,1-1.33-.51v.62a9.31,9.31,0,0,1-.23,2.12,7,7,0,0,0,1.45.44c3.54.64,5.29-1.67,5.86-4.81S341.74,209.65,338.21,209Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.74,221.31c0-.74-9.8-1.11-19.59-1.11s-19.59.37-19.59,1.11v1c0,1.47,8.77,3.63,19.59,3.63s19.59-2.16,19.59-3.63Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.74,221.31c0-.74-9.8-1.11-19.59-1.11s-19.59.37-19.59,1.11v1c0,1.47,8.77,3.63,19.59,3.63s19.59-2.16,19.59-3.63Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.74,221.31c0,1.47-8.77,2.66-19.59,2.66s-19.59-1.19-19.59-2.66c0-.74,9.79-1.11,19.59-1.11S372.74,220.57,372.74,221.31Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.74,221.31c0,1.47-8.77,2.66-19.59,2.66s-19.59-1.19-19.59-2.66c0-.74,9.79-1.11,19.59-1.11S372.74,220.57,372.74,221.31Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,222.82c0,.63-3.09,1.15-6.89,1.15s-6.89-.52-6.89-1.15,3.08-1.16,6.89-1.16S360,222.18,360,222.82Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.94,203.6a1.92,1.92,0,0,0-2.87.59l-.4.63a2,2,0,0,0-1.56.76c-.42.51-.77.91-1.11,1.27a1.53,1.53,0,0,0-1.85.06A29.3,29.3,0,0,1,359.4,209a2.13,2.13,0,0,0-2.28-.39,21.08,21.08,0,0,1-4.77,1.66,2.08,2.08,0,0,0-1.52,1.66c-.78.06-1.63.09-2.64.1a1.52,1.52,0,0,0-1.46,1.15c-.49-.06-1-.15-1.66-.26a2.06,2.06,0,0,0-1.69.43l-.71-.23a1.91,1.91,0,0,0-2.57,1.4,2.74,2.74,0,0,0,1.88,3l.56.19a3,3,0,0,0,2.31,2.11c.9.16,1.6.27,2.28.35a2.22,2.22,0,0,0,2.19,1.84c1.15,0,2.13,0,3-.09a2.85,2.85,0,0,0,2.72.92,27.78,27.78,0,0,0,7.87-2.74,2.8,2.8,0,0,0,1.54-2.33,36.15,36.15,0,0,0,3.25-2.49,2.22,2.22,0,0,0,.49-2.82c.47-.5.93-1,1.51-1.74a3,3,0,0,0,.41-3.1l.31-.51A2.74,2.74,0,0,0,369.94,203.6Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.94,203.6a1.92,1.92,0,0,0-2.87.59l-.4.63a2,2,0,0,0-1.56.76c-.42.51-.77.91-1.11,1.27a1.53,1.53,0,0,0-1.85.06A29.3,29.3,0,0,1,359.4,209a2.13,2.13,0,0,0-2.28-.39,21.08,21.08,0,0,1-4.77,1.66,2.08,2.08,0,0,0-1.52,1.66c-.78.06-1.63.09-2.64.1a1.52,1.52,0,0,0-1.46,1.15c-.49-.06-1-.15-1.66-.26a2.06,2.06,0,0,0-1.69.43l-.71-.23a1.91,1.91,0,0,0-2.57,1.4,2.74,2.74,0,0,0,1.88,3l.56.19a3,3,0,0,0,2.31,2.11c.9.16,1.6.27,2.28.35a2.22,2.22,0,0,0,2.19,1.84c1.15,0,2.13,0,3-.09a2.85,2.85,0,0,0,2.72.92,27.78,27.78,0,0,0,7.87-2.74,2.8,2.8,0,0,0,1.54-2.33,36.15,36.15,0,0,0,3.25-2.49,2.22,2.22,0,0,0,.49-2.82c.47-.5.93-1,1.51-1.74a3,3,0,0,0,.41-3.1l.31-.51A2.74,2.74,0,0,0,369.94,203.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,213.24s-1.15,6.2.57,6.73S351.17,213.24,351.17,213.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,214.26s-1,4.29.24,4.6S347,214.26,347,214.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.09,213.9s-.68,2.83,0,3.2S343.09,213.9,343.09,213.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.39,210.33s4.87,4,3.9,5.51S360.39,210.33,360.39,210.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.72,207.42s3.56,2.6,2.78,3.66S364.72,207.42,364.72,207.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.43,204.65s2.35,1.72,2.07,2.45S367.43,204.65,367.43,204.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,210.41a1.92,1.92,0,0,0-2.9-.43l-.59.46a2,2,0,0,0-1.73.18c-.57.32-1,.58-1.48.81a1.51,1.51,0,0,0-1.76-.58,27,27,0,0,1-3.29,1,2.13,2.13,0,0,0-2-1.15,20.4,20.4,0,0,1-5.06-.08,2.13,2.13,0,0,0-2,1c-.76-.21-1.56-.47-2.51-.81a1.51,1.51,0,0,0-1.76.58c-.45-.23-.91-.49-1.48-.81a2,2,0,0,0-1.73-.18l-.59-.46a1.92,1.92,0,0,0-2.9.43,2.77,2.77,0,0,0,.73,3.49l.47.36a3,3,0,0,0,1.44,2.78c.79.46,1.41.81,2,1.12a2.23,2.23,0,0,0,1.43,2.47c1.08.39,2,.7,2.87,1a2.85,2.85,0,0,0,2.24,1.8,27.76,27.76,0,0,0,8.34.13,2.79,2.79,0,0,0,2.24-1.65,38.18,38.18,0,0,0,3.91-1.23,2.23,2.23,0,0,0,1.43-2.47c.61-.31,1.23-.66,2-1.12a3,3,0,0,0,1.44-2.78l.47-.36A2.77,2.77,0,0,0,370.4,210.41Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,210.41a1.92,1.92,0,0,0-2.9-.43l-.59.46a2,2,0,0,0-1.73.18c-.57.32-1,.58-1.48.81a1.51,1.51,0,0,0-1.76-.58,27,27,0,0,1-3.29,1,2.13,2.13,0,0,0-2-1.15,20.4,20.4,0,0,1-5.06-.08,2.13,2.13,0,0,0-2,1c-.76-.21-1.56-.47-2.51-.81a1.51,1.51,0,0,0-1.76.58c-.45-.23-.91-.49-1.48-.81a2,2,0,0,0-1.73-.18l-.59-.46a1.92,1.92,0,0,0-2.9.43,2.77,2.77,0,0,0,.73,3.49l.47.36a3,3,0,0,0,1.44,2.78c.79.46,1.41.81,2,1.12a2.23,2.23,0,0,0,1.43,2.47c1.08.39,2,.7,2.87,1a2.85,2.85,0,0,0,2.24,1.8,27.76,27.76,0,0,0,8.34.13,2.79,2.79,0,0,0,2.24-1.65,38.18,38.18,0,0,0,3.91-1.23,2.23,2.23,0,0,0,1.43-2.47c.61-.31,1.23-.66,2-1.12a3,3,0,0,0,1.44-2.78l.47-.36A2.77,2.77,0,0,0,370.4,210.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.45,213s-3.2,5.43-1.76,6.51S349.45,213,349.45,213Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.14,212.53s-2.45,3.67-1.35,4.4S345.14,212.53,345.14,212.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.65,210.86s-1.62,2.43-1.1,3S341.65,210.86,341.65,210.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.12,213.46s3.2,5.43,1.77,6.51S359.12,213.46,359.12,213.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.19,212.21s2.45,3.66,1.35,4.39S364.19,212.21,364.19,212.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.68,210.54s1.62,2.42,1.11,3S367.68,210.54,367.68,210.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.69,185.48l-16.92-1.78a2.25,2.25,0,0,0-2.47,2L344,197.9a2.24,2.24,0,0,0,2,2.47l4,.42,4,5,5-4,4,.42a2.25,2.25,0,0,0,2.47-2l1.28-12.2A2.24,2.24,0,0,0,364.69,185.48Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.69,185.48l-16.92-1.78a2.25,2.25,0,0,0-2.47,2L344,197.9a2.24,2.24,0,0,0,2,2.47l4,.42,4,5,5-4,4,.42a2.25,2.25,0,0,0,2.47-2l1.28-12.2A2.24,2.24,0,0,0,364.69,185.48Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.7,190.43a2.86,2.86,0,0,0-4-.42l-2.22,1.8-1.79-2.22a2.85,2.85,0,1,0-4.43,3.59l3.59,4.43a2.84,2.84,0,0,0,4,.42l4.44-3.59A2.85,2.85,0,0,0,361.7,190.43Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.73 194.48 302.15 204.21 311.03 213.94 312.73 194.48",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.73 194.48 302.15 204.21 311.03 213.94 312.73 194.48",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21,241.22H97.93a2.71,2.71,0,0,1-2.74-3l4.62-52.75a3.33,3.33,0,0,1,3.26-3h79.29a2.71,2.71,0,0,1,2.74,3l-4.62,52.75A3.34,3.34,0,0,1,177.21,241.22Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21,241.22H97.93a2.71,2.71,0,0,1-2.74-3l4.62-52.75a3.33,3.33,0,0,1,3.26-3h79.29a2.71,2.71,0,0,1,2.74,3l-4.62,52.75A3.34,3.34,0,0,1,177.21,241.22Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.24,190l-3.82,43.61a2.48,2.48,0,0,0,2.5,2.74h70.15a3.05,3.05,0,0,0,3-2.74L179.86,190a2.46,2.46,0,0,0-2.49-2.74H107.21A3,3,0,0,0,104.24,190Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.24,190l-3.82,43.61a2.48,2.48,0,0,0,2.5,2.74h70.15a3.05,3.05,0,0,0,3-2.74L179.86,190a2.46,2.46,0,0,0-2.49-2.74H107.21A3,3,0,0,0,104.24,190Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.81,230.41h-1.73a.8.8,0,0,1-.81-.72l-1.81-16.28H171l1.77,15.94A1,1,0,0,1,171.81,230.41Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.81,230.41h-1.73a.8.8,0,0,1-.81-.72l-1.81-16.28H171l1.77,15.94A1,1,0,0,1,171.81,230.41Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.39,230.41h-53a2.28,2.28,0,0,1-2.23-3.12l8.56-29.88a4.47,4.47,0,0,1,4-3.12h53a2.27,2.27,0,0,1,2.22,3.12l-8.55,29.88A4.49,4.49,0,0,1,160.39,230.41Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.39,230.41h-53a2.28,2.28,0,0,1-2.23-3.12l8.56-29.88a4.47,4.47,0,0,1,4-3.12h53a2.27,2.27,0,0,1,2.22,3.12l-8.55,29.88A4.49,4.49,0,0,1,160.39,230.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.49,194.29h-2.75a2.27,2.27,0,0,1,2.22,3.12l-8.55,29.88a4.49,4.49,0,0,1-4,3.12h2.75a4.47,4.47,0,0,0,4-3.12l8.56-29.88A2.28,2.28,0,0,0,173.49,194.29Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.49,194.29h-2.75a2.27,2.27,0,0,1,2.22,3.12l-8.55,29.88a4.49,4.49,0,0,1-4,3.12h2.75a4.47,4.47,0,0,0,4-3.12l8.56-29.88A2.28,2.28,0,0,0,173.49,194.29Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.86 226.97 110.92 226.97 119.3 197.72 167.24 197.72 158.86 226.97",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "158.86 226.97 110.92 226.97 119.3 197.72 167.24 197.72 158.86 226.97",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "181.95 211.85 194.06 200.72 183.9 189.59 181.95 211.85",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.95 211.85 194.06 200.72 183.9 189.59 181.95 211.85",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.83,227.05l11.93-15.21c1.14-1.44,2.48-1.44,3,0l5.47,15.21Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.83,227.05l11.93-15.21c1.14-1.44,2.48-1.44,3,0l5.47,15.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.76,211.84l-11.93,15.21h10.56c-1-.84-3.45-1.29-3-3.23.53-2.52,5.4-1.64,5.9-4s-3-1.64-2.42-4.54a12.91,12.91,0,0,1,2.22-4.41A2.85,2.85,0,0,0,132.76,211.84Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.76,211.84l-11.93,15.21h10.56c-1-.84-3.45-1.29-3-3.23.53-2.52,5.4-1.64,5.9-4s-3-1.64-2.42-4.54a12.91,12.91,0,0,1,2.22-4.41A2.85,2.85,0,0,0,132.76,211.84Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.57,227.05l10.32-7.6a2.33,2.33,0,0,1,3,0l7.09,7.6Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.57,227.05l10.32-7.6a2.33,2.33,0,0,1,3,0l7.09,7.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.89,219.45l-10.32,7.6h10.57c-1.1-.42-3.6-.65-3.39-1.61.27-1.26,5.22-.82,5.47-2s-3.21-.82-2.9-2.27a4.8,4.8,0,0,1,1.74-2.2A2.74,2.74,0,0,0,148.89,219.45Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.89,219.45l-10.32,7.6h10.57c-1.1-.42-3.6-.65-3.39-1.61.27-1.26,5.22-.82,5.47-2s-3.21-.82-2.9-2.27a4.8,4.8,0,0,1,1.74-2.2A2.74,2.74,0,0,0,148.89,219.45Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.93,227.05l11-10.9c1-1,2.38-1,3,0l6.38,10.9Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.93,227.05l11-10.9c1-1,2.38-1,3,0l6.38,10.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,216.15l-11,10.9h10.56c-1-.6-3.53-.93-3.24-2.32.39-1.8,5.3-1.17,5.66-2.89s-3.14-1.17-2.69-3.25a7.78,7.78,0,0,1,2-3.16A2.6,2.6,0,0,0,122,216.15Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,216.15l-11,10.9h10.56c-1-.6-3.53-.93-3.24-2.32.39-1.8,5.3-1.17,5.66-2.89s-3.14-1.17-2.69-3.25a7.78,7.78,0,0,1,2-3.16A2.6,2.6,0,0,0,122,216.15Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.41,204.38l-14-2.79a1.45,1.45,0,0,0-1.71,1.14l-.21,1.05a1.46,1.46,0,0,0,1.14,1.71l14,2.79,9.53,2.73,4.63-1.17a.83.83,0,0,0,.29-1.48l-3.82-2.86Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.41,204.38l-14-2.79a1.45,1.45,0,0,0-1.71,1.14l-.21,1.05a1.46,1.46,0,0,0,1.14,1.71l14,2.79,9.53,2.73,4.63-1.17a.83.83,0,0,0,.29-1.48l-3.82-2.86Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.38 210.5 126.42 205.29 120.32 204.6 119.48 208.81 125.38 210.5",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.72,206.29a5.84,5.84,0,0,1-5.43,4.47,3.51,3.51,0,0,1-3.52-4.47,5.83,5.83,0,0,1,5.42-4.48A3.52,3.52,0,0,1,157.72,206.29Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.72,206.29a5.84,5.84,0,0,1-5.43,4.47,3.51,3.51,0,0,1-3.52-4.47,5.83,5.83,0,0,1,5.42-4.48A3.52,3.52,0,0,1,157.72,206.29Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.85,158.62h-64.4a2,2,0,0,1-2-2.21l3.76-43a2.46,2.46,0,0,1,2.4-2.21H352a2,2,0,0,1,2,2.21l-3.76,43A2.47,2.47,0,0,1,347.85,158.62Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.85,158.62h-64.4a2,2,0,0,1-2-2.21l3.76-43a2.46,2.46,0,0,1,2.4-2.21H352a2,2,0,0,1,2,2.21l-3.76,43A2.47,2.47,0,0,1,347.85,158.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.75,117.32l-3.07,35.19a2,2,0,0,0,2,2.21h56.6a2.46,2.46,0,0,0,2.4-2.21l3.08-35.19a2,2,0,0,0-2-2.2H291.16A2.46,2.46,0,0,0,288.75,117.32Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.75,117.32l-3.07,35.19a2,2,0,0,0,2,2.21h56.6a2.46,2.46,0,0,0,2.4-2.21l3.08-35.19a2,2,0,0,0-2-2.2H291.16A2.46,2.46,0,0,0,288.75,117.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.59 121.98 321.2 115.12 318.83 115.12 318.16 122.84 312.64 142.59 298.85 142.59 301.94 126.14 305.87 115.12 303.41 115.12 299.66 125.62 296.27 143.58 292.71 154.72 295.16 154.72 298.27 144.97 311.97 144.97 309.25 154.72 311.67 154.72 316.88 136.08 332.17 136.08 327.65 154.72 330.06 154.72 334.64 135.83 348.45 132.42 348.61 130.58 333.56 134.29 317.38 134.29 320.32 123.78 336.86 122.65 349.41 121.43 349.57 119.64 336.86 120.87 320.59 121.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.76 125.4 324.77 125.4 321.79 128.39 321.79 132.01 330.74 132.01 330.74 128.39 327.76 125.4",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.76 125.4 324.77 125.4 321.79 128.39 321.79 132.01 330.74 132.01 330.74 128.39 327.76 125.4",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.79 128.39 324.77 125.4 327.76 128.39 327.76 132.01 321.79 132.01 321.79 128.39",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.26,106.89a6.66,6.66,0,0,0-6.66,6.66c0,3.67,6.66,11,6.66,11s6.66-7.32,6.66-11A6.66,6.66,0,0,0,326.26,106.89Zm0,9.43a2.78,2.78,0,1,1,2.78-2.77A2.77,2.77,0,0,1,326.26,116.32Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.39 133.34 275.49 141.52 282.95 149.7 284.39 133.34",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.39 133.34 275.49 141.52 282.95 149.7 284.39 133.34",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.46,173.16H147.08a2,2,0,0,1-2-2.21l5-57.38a2.45,2.45,0,0,1,2.4-2.21h57.38a2,2,0,0,1,2,2.21l-5,57.38A2.47,2.47,0,0,1,204.46,173.16Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.46,173.16H147.08a2,2,0,0,1-2-2.21l5-57.38a2.45,2.45,0,0,1,2.4-2.21h57.38a2,2,0,0,1,2,2.21l-5,57.38A2.47,2.47,0,0,1,204.46,173.16Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.38,117.17,149,167.34a2,2,0,0,0,2,2.21h50.16a2.46,2.46,0,0,0,2.41-2.21L208,117.17a2,2,0,0,0-2-2.21H155.78A2.45,2.45,0,0,0,153.38,117.17Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.38,117.17,149,167.34a2,2,0,0,0,2,2.21h50.16a2.46,2.46,0,0,0,2.41-2.21L208,117.17a2,2,0,0,0-2-2.21H155.78A2.45,2.45,0,0,0,153.38,117.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.84 153.99 198.01 121.65 194.87 121.98 190.23 155.4 203.84 153.99",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.84 153.99 198.01 121.65 194.87 121.98 190.23 155.4 203.84 153.99",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.33 155.08 150.81 159.51 155.49 126.08 198.01 121.65 193.33 155.08",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.33 155.08 150.81 159.51 155.49 126.08 198.01 121.65 193.33 155.08",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.69 132.57 157.53 135.09 158.02 131.55 182.19 129.03 181.69 132.57",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.93 148.69 155.56 149.14 156.18 144.74 160.55 144.28 159.93 148.69",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.06 154.93 154.69 155.39 155.3 150.99 159.67 150.53 159.06 154.93",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.93 148.69 155.56 149.14 156.18 144.74 160.55 144.28 159.93 148.69",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.06 154.93 154.69 155.39 155.3 150.99 159.67 150.53 159.06 154.93",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.81 142.44 156.44 142.89 157.05 138.49 161.42 138.03 160.81 142.44",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.89 141.8 162.52 142.26 163.13 137.86 167.5 137.4 166.89 141.8",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.81 142.44 156.44 142.89 157.05 138.49 161.42 138.03 160.81 142.44",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.89 141.8 162.52 142.26 163.13 137.86 167.5 137.4 166.89 141.8",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.01 148.05 161.64 148.51 162.26 144.1 166.63 143.65 166.01 148.05",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.14 154.3 160.77 154.75 161.38 150.35 165.75 149.9 165.14 154.3",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.97 141.17 168.6 141.63 169.22 137.22 173.59 136.77 172.97 141.17",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.1 147.42 167.73 147.87 168.34 143.47 172.71 143.02 172.1 147.42",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.22 153.67 166.85 154.12 167.47 149.72 171.84 149.26 171.22 153.67",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.05 140.54 174.68 140.99 175.3 136.59 179.67 136.13 179.05 140.54",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.18 146.78 173.81 147.24 174.43 142.84 178.79 142.38 178.18 146.78",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.31 153.03 172.94 153.49 173.55 149.09 177.92 148.63 177.31 153.03",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.14 139.9 180.77 140.36 181.38 135.96 185.75 135.5 185.14 139.9",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.26 146.15 179.89 146.61 180.51 142.2 184.88 141.75 184.26 146.15",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.39 152.4 179.02 152.85 179.63 148.45 184 148 183.39 152.4",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.01 148.05 161.64 148.51 162.26 144.1 166.63 143.65 166.01 148.05",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.14 154.3 160.77 154.75 161.38 150.35 165.75 149.9 165.14 154.3",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.97 141.17 168.6 141.63 169.22 137.22 173.59 136.77 172.97 141.17",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.1 147.42 167.73 147.87 168.34 143.47 172.71 143.02 172.1 147.42",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.22 153.67 166.85 154.12 167.47 149.72 171.84 149.26 171.22 153.67",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.05 140.54 174.68 140.99 175.3 136.59 179.67 136.13 179.05 140.54",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.18 146.78 173.81 147.24 174.43 142.84 178.79 142.38 178.18 146.78",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.31 153.03 172.94 153.49 173.55 149.09 177.92 148.63 177.31 153.03",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.14 139.9 180.77 140.36 181.38 135.96 185.75 135.5 185.14 139.9",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.26 146.15 179.89 146.61 180.51 142.2 184.88 141.75 184.26 146.15",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.39 152.4 179.02 152.85 179.63 148.45 184 148 183.39 152.4",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.22 139.27 186.85 139.72 187.47 135.32 191.83 134.87 191.22 139.27",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.34 145.52 185.97 145.97 186.59 141.57 190.96 141.12 190.34 145.52",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.22 139.27 186.85 139.72 187.47 135.32 191.83 134.87 191.22 139.27",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.34 145.52 185.97 145.97 186.59 141.57 190.96 141.12 190.34 145.52",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.47 151.77 185.1 152.22 185.72 147.82 190.09 147.36 189.47 151.77",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.47 151.77 185.1 152.22 185.72 147.82 190.09 147.36 189.47 151.77",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,127.27h0a.76.76,0,0,1-.85-.75l0-1.6a.93.93,0,0,1,.83-.92h0a.76.76,0,0,1,.85.75l0,1.6A.93.93,0,0,1,159.49,127.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.21,126.78h0a.77.77,0,0,1-.86-.75l0-1.6a.93.93,0,0,1,.82-.92h0a.77.77,0,0,1,.86.75l0,1.6A.94.94,0,0,1,164.21,126.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.92,126.29h0a.76.76,0,0,1-.85-.75l0-1.6a.93.93,0,0,1,.83-.92h0a.76.76,0,0,1,.85.75l0,1.6A1,1,0,0,1,168.92,126.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.64,125.79h0a.75.75,0,0,1-.86-.74l0-1.6a1,1,0,0,1,.83-.92h0a.75.75,0,0,1,.85.74l0,1.6A.92.92,0,0,1,173.64,125.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.35,125.3h0a.75.75,0,0,1-.85-.74l0-1.6a.93.93,0,0,1,.82-.92h0a.76.76,0,0,1,.86.74l0,1.6A.94.94,0,0,1,178.35,125.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.07,124.81h0a.75.75,0,0,1-.86-.74l0-1.6a.94.94,0,0,1,.83-.92h0a.75.75,0,0,1,.85.74l0,1.6A.93.93,0,0,1,183.07,124.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.78,124.32h0a.76.76,0,0,1-.86-.74l0-1.6a.92.92,0,0,1,.82-.92h0a.76.76,0,0,1,.86.74l0,1.6A.93.93,0,0,1,187.78,124.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.49,123.83h0a.76.76,0,0,1-.85-.74l0-1.6a.92.92,0,0,1,.83-.92h0a.75.75,0,0,1,.85.74l0,1.6A.93.93,0,0,1,192.49,123.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.49,127.27h0a.76.76,0,0,1-.85-.75l0-1.6a.93.93,0,0,1,.83-.92h0a.76.76,0,0,1,.85.75l0,1.6A.93.93,0,0,1,159.49,127.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.21,126.78h0a.77.77,0,0,1-.86-.75l0-1.6a.93.93,0,0,1,.82-.92h0a.77.77,0,0,1,.86.75l0,1.6A.94.94,0,0,1,164.21,126.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.92,126.29h0a.76.76,0,0,1-.85-.75l0-1.6a.93.93,0,0,1,.83-.92h0a.76.76,0,0,1,.85.75l0,1.6A1,1,0,0,1,168.92,126.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.64,125.79h0a.75.75,0,0,1-.86-.74l0-1.6a1,1,0,0,1,.83-.92h0a.75.75,0,0,1,.85.74l0,1.6A.92.92,0,0,1,173.64,125.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.35,125.3h0a.75.75,0,0,1-.85-.74l0-1.6a.93.93,0,0,1,.82-.92h0a.76.76,0,0,1,.86.74l0,1.6A.94.94,0,0,1,178.35,125.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.07,124.81h0a.75.75,0,0,1-.86-.74l0-1.6a.94.94,0,0,1,.83-.92h0a.75.75,0,0,1,.85.74l0,1.6A.93.93,0,0,1,183.07,124.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.78,124.32h0a.76.76,0,0,1-.86-.74l0-1.6a.92.92,0,0,1,.82-.92h0a.76.76,0,0,1,.86.74l0,1.6A.93.93,0,0,1,187.78,124.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.49,123.83h0a.76.76,0,0,1-.85-.74l0-1.6a.92.92,0,0,1,.83-.92h0a.75.75,0,0,1,.85.74l0,1.6A.93.93,0,0,1,192.49,123.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.36,143.36a7.46,7.46,0,0,1,2.75,0c1.79.54.08,2.49-1.05,2.88s-2.91.13-3.32-1.15c-.48-1.5,1.22-2.56,2.5-2.76.35,0,.34-.58,0-.53-1.54.23-3.33,1.4-3.08,3.16.24,1.6,2.07,2.21,3.54,1.91,1.32-.26,3.11-1.59,2.7-3.11s-2.88-1.09-4-1c-.34,0-.33.57,0,.53Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.36,143.36a7.46,7.46,0,0,1,2.75,0c1.79.54.08,2.49-1.05,2.88s-2.91.13-3.32-1.15c-.48-1.5,1.22-2.56,2.5-2.76.35,0,.34-.58,0-.53-1.54.23-3.33,1.4-3.08,3.16.24,1.6,2.07,2.21,3.54,1.91,1.32-.26,3.11-1.59,2.7-3.11s-2.88-1.09-4-1c-.34,0-.33.57,0,.53Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "207.06 153.95 217.65 144.22 208.77 134.49 207.06 153.95",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.06 153.95 217.65 144.22 208.77 134.49 207.06 153.95",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.76,124.51c-7.46.09-23-1.89-19.37,28.35a17.55,17.55,0,0,1-1.14,7.89l4.63,1.42s.62-4.8,0-6.93c0,0,2.56,2.06,1.66,7.5l4.25,1,.73-7,5.07-.42,2.14-.14,2-1s-.19,4.63,1.08,7.5l4.33-2s-2.34-3.54-1.14-6.37c0,0,1.58,3.76,2.74,4.86l2.83-1.91s-1.9-3.4-.9-9.71,2.07-7.89,2.07-7.89-1.14,7.23,0,7.89l1.52-1.89a7.67,7.67,0,0,1-.25-7.23C262.89,134.25,257.41,124.41,248.76,124.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.72,
    y: 216.25,
    width: 31.44,
    height: 17.71,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.13 387.7 291.44 401.82 283.92 402.45 281.15 389.77 289.13 387.7",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.53,403.43a3.74,3.74,0,0,1-2.6-.48.8.8,0,0,1-.05-.9,1.08,1.08,0,0,1,.62-.53c1.42-.5,4.57,1,4.71,1.09a.2.2,0,0,1,.11.21.23.23,0,0,1-.15.18A15.79,15.79,0,0,1,279.53,403.43Zm-1.5-1.59a1.34,1.34,0,0,0-.39.07.58.58,0,0,0-.38.32c-.14.27-.07.39,0,.45.44.54,2.63.4,4.23.09A9.42,9.42,0,0,0,278,401.84Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.14,403a.14.14,0,0,1-.09,0c-1.07-.38-3.29-2.12-3.17-3.11,0-.24.16-.54.72-.63a1.49,1.49,0,0,1,1.17.27c1.17.83,1.57,3.16,1.59,3.26a.22.22,0,0,1-.08.2A.23.23,0,0,1,282.14,403Zm-2.37-3.37h-.12c-.37.05-.38.2-.39.26,0,.59,1.45,2,2.58,2.53a4.88,4.88,0,0,0-1.34-2.58,1.06,1.06,0,0,0-.73-.21Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,401.72l9.48-.67a.78.78,0,0,1,.79.55l2.25,7.59a1.26,1.26,0,0,1-.84,1.58,1.31,1.31,0,0,1-.27.06c-3.42.18-6.47.2-10.72.51-5,.35-3.71.86-9.61,1.36-3.55.3-4.48-3.7-3-4,6.84-1.36,7.41-3.49,9.9-6.15A3.08,3.08,0,0,1,283,401.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.49 389.93 290.36 395.22 282.64 396.59 281.72 392.38 289.49 389.93",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.74 386.96 238.23 401.19 230.82 399.82 231.49 386.85 239.74 386.96",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,399.91c-1.1-.24-2.19-.7-2.45-1.25a.81.81,0,0,1,.22-.91,1.12,1.12,0,0,1,.77-.34c1.57-.08,4.27,2.37,4.39,2.48a.23.23,0,0,1,.05.24.24.24,0,0,1-.21.14A16.16,16.16,0,0,1,225.08,399.91Zm-1-2a1.17,1.17,0,0,0-.41,0,.58.58,0,0,0-.48.2c-.22.23-.19.37-.15.45.29.67,2.52,1.18,4.21,1.34A9.88,9.88,0,0,0,224.06,397.88Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.82,400.26l-.09,0c-.95-.71-2.65-3.1-2.24-4.06.07-.23.32-.49.91-.41a1.59,1.59,0,0,1,1.09.61c.92,1.18.62,3.63.61,3.74a.2.2,0,0,1-.14.17A.22.22,0,0,1,227.82,400.26Zm-1.37-4.08-.12,0c-.38,0-.44.09-.47.14-.19.59.88,2.4,1.83,3.3a5.05,5.05,0,0,0-.57-3,1.16,1.16,0,0,0-.67-.43Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.94,399.18l8.3,1.85a.79.79,0,0,1,.63.77v8.26c-1.35,2.33-6.19-.86-10-1.06a66.48,66.48,0,0,1-13.38-2.12c-3.64-.76-1.53-5.18,0-5C222.78,402.52,229.19,399,229.94,399.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.5 389.21 238.94 394.54 231.13 393.82 231.35 389.51 239.5 389.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.65,225.4l-1.89,87.12.89,76.71,13.47,1.48s4-25.3,4.83-45.94c.63-16.74-.84-23.18-.47-30.9.67-14.12,9.3-35.56,10.17-56,.38-8.7,1-34.83,1-34.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.07,250.45A261.07,261.07,0,0,0,249.75,291c.91-4.26,2.46-9.13,3.24-13.62A123.69,123.69,0,0,0,255.83,253l-3.36-.8Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.92,228l20.69,87.69,16.82,76.38,13.51-2.2s-2.26-32.61-4.36-43.33c-3.67-18.78-6.63-24.67-8.05-33.06-3.62-21.39-1.41-65.62-14-85.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5,228H253.35c0-2.43,0-4,0-4l-24.81,3.13,0,8c2.17.83,7.17,2.27,14.7,1.67l2.07-9.38,7,8.69a59.84,59.84,0,0,0,15.1-2.21A37.62,37.62,0,0,0,264.5,228Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.82,199.43s3.43,10.19,5.78,16.82c1.82,5.1,5.23,14.43,5.23,14.43s6.44,4.23,7.08,7S299,244,295.71,244s-3.59-.74-5.24-4.32-4.14-4.32-4.05-7l-14.79-29.78Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.8 208.12 282.11 203.5 281.05 200.71 274.7 176.86 264.5 184.03 270.7 203.19 272.8 208.12",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.8 208.12 282.11 203.5 281.05 200.71 274.7 176.86 264.5 184.03 270.7 203.19 272.8 208.12",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.16 206.69 272.63 209.29 283.02 204.39 282.11 200.99 271.16 206.69",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.16 206.69 272.63 209.29 283.02 204.39 282.11 200.99 271.16 206.69",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.25,164.31s6.43-.92,9.37,3.22a72,72,0,0,1,5.7,10.3,61.4,61.4,0,0,1-13.6,9.74S251.77,166.52,262.25,164.31Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,187.57a43.34,43.34,0,0,0,5-2.88l-2.25-13.88-5.13,11.87C262.57,185.54,263.72,187.57,263.72,187.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.1,245.7l-2.07,1a.3.3,0,0,1-.4-.39l1-2.08.06-.08,13.07-13.07a.85.85,0,0,1,1.2,0l.3.3a.86.86,0,0,1,0,1.21l-13.07,13.06A.16.16,0,0,1,288.1,245.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.1,245.7l-2.07,1a.3.3,0,0,1-.4-.39l1-2.08.06-.08,13.07-13.07a.85.85,0,0,1,1.2,0l.3.3a.86.86,0,0,1,0,1.21l-13.07,13.06A.16.16,0,0,1,288.1,245.7Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.13,
    y: 231.76,
    width: 0.75,
    height: 2.13,
    transform: "translate(-76.9 279.97) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.1,245.31l-.47,1a.3.3,0,0,0,.4.39l1-.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.13,
    y: 231.76,
    width: 0.75,
    height: 2.13,
    transform: "translate(-76.9 279.97) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.1,245.31l-.47,1a.3.3,0,0,0,.4.39l1-.47Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,237.86s1.26,3,2.74,3.22-1.07-5.91-1.07-5.91Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.6,164.64a191.78,191.78,0,0,1,26.92-1.25L251.86,175l-9.92,3.31-6.76-1.65-6-6.48Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.6,164.64a191.78,191.78,0,0,1,26.92-1.25L251.86,175l-9.92,3.31-6.76-1.65-6-6.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.67,169.6l5.62-5.12a6.59,6.59,0,0,1-2.23-6.19,21.86,21.86,0,0,1,.42-2.55l-6.27-5.23-4.59-3.82c1.24,5.57,2.64,15.17-1.16,18.89C239.15,167,241.89,168.35,244.67,169.6Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.6,215.19,226,230.86s8.37,3.59,16.46,3l2.56-9.32v-8.51l1.11,8.51,6.25,8.68s10.67,0,17.38-3.58A152.34,152.34,0,0,0,262,214.78S237.16,213.12,227.6,215.19Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.6,215.19,226,230.86s8.37,3.59,16.46,3l2.56-9.32v-8.51l1.11,8.51,6.25,8.68s10.67,0,17.38-3.58A152.34,152.34,0,0,0,262,214.78S237.16,213.12,227.6,215.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.26,164.09c-2.12-.29-5.27-.65-9.13-.85-1.13,3.78-6.66,9.58-12.28,9.58s-9.41-4.93-10.16-8.52c-1.54.24-3.11.5-4.69.82a4.41,4.41,0,0,0-3.43,3.24c-1.43,5.73-3.62,21,2.66,49.36a141.37,141.37,0,0,0,17.82.46c5.23-.14,11.45.33,18.39-1.2l3.64-49.38A3.28,3.28,0,0,0,264.26,164.09Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.66 164.23 237.16 163.44 243.5 169.05 240.56 172.19 233.66 164.23",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.66 164.23 237.16 163.44 243.5 169.05 240.56 172.19 233.66 164.23",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.82 163.12 250.32 162.8 242.88 169.05 245.82 172.19 253.82 163.12",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.82 163.12 250.32 162.8 242.88 169.05 245.82 172.19 253.82 163.12",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.48,155.74a21.86,21.86,0,0,0-.42,2.55c-2.36-.47-5.88-2.57-6.21-5.22a11.05,11.05,0,0,1,.36-2.56Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.89,202.23l-1.67,2.91a1.26,1.26,0,0,0,.05,1.36,6.26,6.26,0,0,0,2.18,1.8,6.93,6.93,0,0,0,2.71.87,1.28,1.28,0,0,0,1.09-.5l2.87-3.69Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.1 178.93 203.33 200.9 211.97 205.58 227.32 185.73 216.1 178.93",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.1 178.93 203.33 200.9 211.97 205.58 227.32 185.73 216.1 178.93",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.6,189.24l1-3.13A129.77,129.77,0,0,0,203.51,201l6.54,3.55,1.23-.52,5.55-4.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.16,164.9s-8-.57-15.62,15.48c0,0,7.07,6.07,14.27,8.51C227.81,188.89,237.8,165.76,229.16,164.9Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.4,187.48l-.89-13.11-2.81,11.1C221.86,186.17,223.11,186.85,224.4,187.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.59 199.43 213.54 204.85 211.79 206.87 201.47 202.55 202.59 199.43",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.59 199.43 213.54 204.85 211.79 206.87 201.47 202.55 202.59 199.43",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.1,
    y: 167.72,
    width: 22.65,
    height: 28.97,
    rx: 1.99,
    transform: "translate(-17.53 25.58) rotate(-5.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.1,
    y: 167.72,
    width: 22.65,
    height: 28.97,
    rx: 1.99,
    transform: "translate(-17.53 25.58) rotate(-5.92)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.9,196.12,231,198a2.8,2.8,0,0,1-3.06-2.49l-2.5-24.15a2.78,2.78,0,0,1,2.48-3.06l17.87-1.85a2.78,2.78,0,0,1,3.06,2.48l2.5,24.16A2.78,2.78,0,0,1,248.9,196.12Zm-20.86-27a1.92,1.92,0,0,0-1.7,2.09l2.51,24.15a1.9,1.9,0,0,0,2.09,1.7l17.87-1.86a1.89,1.89,0,0,0,1.69-2.08L248,169a1.91,1.91,0,0,0-2.09-1.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.9,196.12,231,198a2.8,2.8,0,0,1-3.06-2.49l-2.5-24.15a2.78,2.78,0,0,1,2.48-3.06l17.87-1.85a2.78,2.78,0,0,1,3.06,2.48l2.5,24.16A2.78,2.78,0,0,1,248.9,196.12Zm-20.86-27a1.92,1.92,0,0,0-1.7,2.09l2.51,24.15a1.9,1.9,0,0,0,2.09,1.7l17.87-1.86a1.89,1.89,0,0,0,1.69-2.08L248,169a1.91,1.91,0,0,0-2.09-1.69Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.1,
    y: 170.54,
    width: 4.93,
    height: 4.93,
    rx: 1.07,
    transform: "translate(-16.62 24.72) rotate(-5.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.1,
    y: 170.54,
    width: 4.93,
    height: 4.93,
    rx: 1.07,
    transform: "translate(-16.62 24.72) rotate(-5.92)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.77,172.88a1.22,1.22,0,1,1-1.33-1.08A1.22,1.22,0,0,1,231.77,172.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,188.24s-34.16,14.07-28.37,20.14c4,4.15,12,1,29.91-16.72C229.79,191.66,231,189.59,228.25,188.24Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.93,182.47a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,240.93,182.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.6,189.38s4.52-5.59,7.84-6a32.56,32.56,0,0,1,5.93-.13s4.18,7.46,0,8.43c-3.18.74-3.3.53-4.87,1-1.75.51-1.62.3-6.71.52Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.4 386.3 293.81 392.53 277.18 395.6 275.12 389.42 293.4 386.3",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.23 386.73 242.98 392.85 226.13 391.42 225.77 384.92 244.23 386.73",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.94,141.76a8,8,0,0,0,2.93,4.6c1.91,1.4,3.35-.3,3.25-2.69-.1-2.16-1.2-5.48-3.31-5.92S233.42,139.46,233.94,141.76Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.09,135.43c-1,7.52-1.91,11.86,1.14,16.48,4.52,6.93,14.24,5.48,17.37-1.56,2.86-6.32,3.87-17.56-2.77-22.06a10,10,0,0,0-15.74,7.14Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43,142c-.07.56.18,1.06.54,1.11s.73-.38.81-.94-.18-1.07-.54-1.12S248.53,141.5,248.43,142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.83,142.86c-.06.58.18,1.07.55,1.12s.73-.38.8-.95-.17-1.06-.54-1.1S254.91,142.3,254.83,142.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.47,141.93l1.41-.22S256.05,142.69,255.47,141.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.73,143.64a15.19,15.19,0,0,0,1.57,3.88,2.52,2.52,0,0,1-2.08.12Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.86,149.46a4.7,4.7,0,0,0,.83.17.16.16,0,0,0,.19-.13h0a.18.18,0,0,0-.16-.18,4.57,4.57,0,0,1-3.44-2.23.16.16,0,0,0-.22-.07.17.17,0,0,0-.08.22A4.68,4.68,0,0,0,248.86,149.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,140.42a.32.32,0,0,0,.37-.13,4,4,0,0,1,2.88-1.34.34.34,0,0,0,.34-.34.33.33,0,0,0-.33-.33h0a4.57,4.57,0,0,0-3.43,1.64.34.34,0,0,0,.09.46h0A.18.18,0,0,0,246,140.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.13,140.15a.38.38,0,0,0,.34-.08.35.35,0,0,0,0-.48,3.29,3.29,0,0,0-2.9-1.08.32.32,0,0,0-.28.36v0a.33.33,0,0,0,.38.27h0A2.71,2.71,0,0,1,257,140,.36.36,0,0,0,257.13,140.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.05,141.16l1.41-.22S249.64,141.88,249.05,141.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,128.1s1.34,6.16-2.72,9.34a27.37,27.37,0,0,0-5.36,1.1,10.49,10.49,0,0,0,1.42-4.26s-2,4.26-3.73,5.22a15.12,15.12,0,0,0-4.74,1.92,17.14,17.14,0,0,1,1.82-5.75,19.49,19.49,0,0,0-4.19,11.73L232.89,145V135l2-4.48,4.59-3.09,2-1.28s4.84.32,5.11,0,3.36-.43,3.36-.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.93,129.94s5,.4,5.22,7.76a3.32,3.32,0,0,1,2.29,2.1,6.62,6.62,0,0,0,.59-3.55s-.81-3.82-.87-4.05-1.75-2.83-1.75-2.83L254,127.69l-.55-.37Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.6f88823a4d2449d5d180f9e63acce5e5.svg";
export { ForwardRef as ReactComponent };